import { Instance, types } from 'mobx-state-tree';

export const MediaDisplayStore = types
  .model('MediaDisplayStore', {
    currentPage: types.optional(types.number, 1),
  })
  .actions((self) => ({
    setPage(page: number) {
      self.currentPage = page;
    },
  }));

export interface IMediaDisplayStore extends Instance<typeof MediaDisplayStore> {}
